var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Broker } from './Broker';
export var EventsContext = React.createContext({
    subscribe: function () { return ({}); },
    publish: function () { return ({}); },
    close: function () { return ({}); },
    subscribeAll: function () { return ({}); },
    setCustomData: function () { return ({}); },
});
export var Provider = EventsContext.Provider, Consumer = EventsContext.Consumer;
var publisher = Broker(); // one instance for all application.
export var EventsProvider = function (_a) {
    var children = _a.children, events = _a.events, globalData = _a.globalData, _b = _a.resetBroker, resetBroker = _b === void 0 ? false : _b;
    var _c = React.useState({}), customData = _c[0], setCustomData = _c[1];
    if (Boolean(globalData)) {
        publisher.setGlobalData(globalData);
    }
    if (events) {
        publisher.subscribeAll(events);
        if (!resetBroker) {
            publisher.setMounted();
        }
    }
    React.useEffect(function () {
        if (customData && Object.keys(customData).length) {
            publisher.setGlobalData(__assign(__assign({}, (globalData || {})), customData));
        }
    }, [JSON.stringify(customData)]);
    return React.createElement(Provider, { value: __assign(__assign({}, publisher), { setCustomData: setCustomData }) }, children);
};
